(function(){
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  // ---- Drawer-Helfer ----
  function isDrawerOpen(){
    var el = document.getElementById('cart-drawer');
    return !!(el && (el.hasAttribute('open') || el.classList.contains('is-open') || el.getAttribute('aria-hidden') === 'false'));
  }
  function reopenDrawer(){
    var el = document.getElementById('cart-drawer');
    if (!el) return;
    if (typeof el.open === 'function') el.open();
    else if (window.CartDrawer && typeof window.CartDrawer.open === 'function') window.CartDrawer.open();
    else {
      el.setAttribute('open',''); el.classList.add('is-open'); document.documentElement.classList.add('no-scroll');
    }
  }

  // ---- Sternify Re-Init (und Fallback) ----
  function reinitSternify(){
    try {
      if (window.Sternify && typeof window.Sternify.init === 'function') { window.Sternify.init(); return; }
      if (window.Sternify && typeof window.Sternify.reload === 'function') { window.Sternify.reload(); return; }
      if (typeof window.initializeSternify === 'function') { window.initializeSternify(); return; }
      // Fallback: evtl. Sternify-Script neu laden
      var nodes = [].slice.call(document.querySelectorAll('script[src*="sternify"]'));
      nodes.forEach(function(n){
        if (n.dataset.reloaded) return;
        var src = n.getAttribute('src').split('?')[0];
        var s = document.createElement('script');
        s.src = src + '?v=' + Date.now();
        s.async = true; s.dataset.reloaded = '1';
        document.head.appendChild(s);
      });
    } catch(e){}
  }

  // ---- Section ersetzen + Skripte ausführen + Events + Payment-Buttons + Sternify ----
  function replaceSection(id, html){
    var oldRoot = document.getElementById('shopify-section-' + id);
    if (!oldRoot || !html) return;

    oldRoot.outerHTML = html;

    var newRoot = document.getElementById('shopify-section-' + id);
    if (!newRoot) return;

    var scripts = newRoot.querySelectorAll('script');
    for (var i=0; i<scripts.length; i++){
      var oldScript = scripts[i];
      var s = document.createElement('script');
      for (var j=0; j<oldScript.attributes.length; j++){
        var a = oldScript.attributes[j]; s.setAttribute(a.name, a.value);
      }
      s.text = oldScript.text || '';
      oldScript.parentNode.replaceChild(s, oldScript);
    }

    // Events für Apps
    try {
      var e1=document.createEvent('Event'); e1.initEvent('shopify:section:load', true, true); document.dispatchEvent(e1);
      var e2=document.createEvent('Event'); e2.initEvent('cart:updated',        true, true); document.dispatchEvent(e2);
    } catch(e){}

    // Shopify Express/Payment Buttons neu initialisieren
    try { if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init==='function') Shopify.PaymentButton.init(); } catch(e){}
    try { if (window.Shopify && Shopify.StorefrontExpressButtons && typeof Shopify.StorefrontExpressButtons.initialize==='function') Shopify.StorefrontExpressButtons.initialize(); } catch(e){}

    // Sternify neu initialisieren
    reinitSternify();
  }

  // ---- Sections nachladen (robust, ohne JSON-Zwang) ----
  function refreshSections(keepDrawerOpen){
    var ids = [];
    var d = document.querySelector('section.shopify-section--cart-drawer');
    var c = document.querySelector('section.shopify-section--main-cart');
    if (d) ids.push(d.id.replace('shopify-section-',''));
    if (c) ids.push(c.id.replace('shopify-section-',''));
    if (!ids.length){ location.reload(); return; }

    var reqs = [];
    for (var i=0; i<ids.length; i++){
      var url = location.pathname + (location.search || '') + (location.search ? '&' : '?') + 'section_id=' + ids[i];
      reqs.push(fetch(url, {credentials:'include'}).then(function(r){ return r.text(); }));
    }

    Promise.all(reqs).then(function(htmls){
      for (var i=0; i<ids.length; i++){ replaceSection(ids[i], htmls[i]); }
      if (keepDrawerOpen) reopenDrawer();
    }).catch(function(){ location.reload(); });
  }

  // ---- Rabatt anwenden (ohne Checkout), danach Sections aktualisieren ----
  function setDiscount(code){
    var keepOpen = isDrawerOpen();
    fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root), {credentials:'include', redirect:'follow'})
      .then(function(){ refreshSections(keepOpen); })
      .catch(function(){ location.reload(); });
  }

  // ---- Handler ----
  function applyFrom(container){
    if (!container) return;
    var input = container.querySelector('[data-discount-input], .js-discount-code');
    var err   = container.querySelector('.cart-discount__error');
    var code  = input && input.value ? input.value.trim() : '';
    if (!code){ if (err) err.hidden = false; if (input) input.focus(); return; }
    if (err) err.hidden = true;
    setDiscount(code);
  }

  // Delegierte Events (Drawer & Cart-Seite)
  document.addEventListener('click', function(e){
    var t = e.target;
    while (t && t !== document){
      if (t.hasAttribute && t.hasAttribute('data-apply-discount')){
        e.preventDefault();
        applyFrom(t.closest ? t.closest('.cart-discount') : t.parentNode);
        return;
      }
      t = t.parentNode;
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter') return;
    var t = e.target;
    while (t && t !== document){
      if (t.hasAttribute && (t.hasAttribute('data-discount-input') || (t.classList && t.classList.contains('js-discount-code')))){
        e.preventDefault();
        applyFrom(t.closest ? t.closest('.cart-discount') : t.parentNode);
        return;
      }
      t = t.parentNode;
    }
  });
})();
